exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error {\r\n    color: #a94442;\r\n    background-color: #f2dede;\r\n    border-color: #ebccd1;\r\n    display: none;\r\n    width: 200px;\r\n    height: 25px;\r\n    padding: 3px;\r\n    border-radius: 5px;\r\n    font-size: 14px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/category-money/category-money.component.css
// module id = ../../../../../src/app/_components/category-money/category-money.component.css
// module chunks = main